import { render, staticRenderFns } from "./data.vue?vue&type=template&id=114140bc&scoped=true&"
import script from "./data.vue?vue&type=script&lang=ts&"
export * from "./data.vue?vue&type=script&lang=ts&"
import style0 from "./data.vue?vue&type=style&index=0&id=114140bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114140bc",
  null
  
)

export default component.exports